<template>
<v-layout>
  <v-flex xs12>
  <v-card>
    <v-card-title>
      <v-btn color="info" href="#/network/add" @click="goToAdd()">Add Network</v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="networkList"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.networkId }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.clickIdParameter }}</td>
        <td class="text-xs-left">{{ props.item.postbackUrl }}</td>
        <td class="text-xs-left">{{ props.item.filter }}</td>
        <td class="text-xs-center">{{ props.item.status? 'Active' : 'Inactive' }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteNetwork(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Sorry!!! No result found for your search "{{ search }}".
      </v-alert>
    </v-data-table>
  </v-card>
  </v-flex>

  <v-flex v-if="deleteDialog">
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="title">Do you want to change the status of the network?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" outline @click.native="deleteDialog = false; selectedNetwork = null">Cancel</v-btn>
          <v-btn color="primary" outline @click.native="deleteConfirmed()">Change</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>


  </v-layout>
</template>
<script>
import axios from "axios";
import { SERVER_URL } from "./../../constant.js";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Network ID",
          value: "networkId",
          align: "left"
        },
        {
          text: "Name",
          value: "name",
          align: "left"
        },
        {
          text: "Click Id Parameter",
          align: "left",
          value: "clickIdParameter",
          sortable: false
        },
        {
          text: "Postback Url",
          value: "postback",
          align: "left"
        },
        {
          text: "Filter",
          value: "filter",
          align: "left"
        },
        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: false
        }
      ],
      countries: [],
      networkList: [],

      deleteDialog: false,
      selectedNetwork: null
    };
  },
  created() {
    document.title = 'Networks';
    axios.get(`${SERVER_URL}/network/all`).then(res => {
      this.networkList = res.data;
    });
  },
  methods: {
    goToAdd() {
      this.$router.push("/network/add");
    },
    deleteNetwork ( network ) {
      this.selectedNetwork = network;
      this.deleteDialog = true;
    },
    deleteConfirmed() {
      
      let network = this.selectedNetwork;

      network.status = ! network.status;

      this.deleteDialog = false;

      axios
      .post(`${SERVER_URL}/network/update`, network)
      .then(res => {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Advertiser Url Deleted Successfully"
        });

        document.dispatchEvent(showSnackbarEvent);
        var changedIndex = this.networkList.findIndex(
          netrk =>
            netrk.networkId === network.networkId
        );
        this.$set(this.networkList, changedIndex, network);
        this.selectedNetwork = null;

      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/network/ListNetwork.vue